import React, { useEffect, useContext, useState } from "react";
import "./layout.style.scss";
import Sidebar from "../SideBar/sideBar.component";
import NavBar from "../NavBar/navbar.component";
import { AccountContext } from "../../../Contexts/main.context";
import TheOutlet from "../TheOutlet/theOutlet.component";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";



const Layout = () => {

     const {googleCategories,updateGoogleCategories,userAccounts, updateUserAccounts, clientAccounts, updateClientAccounts,myAccount,updateMyAccount } = useContext(AccountContext);
     // eslint-disable-next-line
     const [actionButtons, setActionButtons] = useState([]);
     const navigate = useNavigate();



     const fetchAccounts = async () => {
          try {
               const response = await fetch("https://www.lgfantasy.ca/Citations/PHP/data.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ script: "getAccounts" }) // or "getAccounts"
               });

               if (!response.ok) {
                    throw new Error("Failed to fetch accounts");
               }
               const data = await response.json();
               return data;

               // Example: setAccounts(data); if using useState
          } catch (error) {
               console.error("Error fetching accounts:", error);
          }
     };


     const fetchUsers = async () => {
          try {
               const response = await fetch("https://www.lgfantasy.ca/Citations/PHP/data.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ script: "getUsers" }) // or "getAccounts"
               });

               if (!response.ok) {
                    throw new Error("Failed to fetch accounts");
               }

               const data = await response.json();
               return data;

               // Example: setAccounts(data); if using useState
          } catch (error) {
               console.error("Error fetching accounts:", error);
          }
     };

     const fetchGoogle = async () => {
          try {
               const response = await fetch("https://www.lgfantasy.ca/Citations/PHP/data.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ script: "getCats" }) // or "getAccounts"
               });

               if (!response.ok) {
                    throw new Error("Failed to fetch accounts");
               }

               const data = await response.json();
               return data;

               // Example: setAccounts(data); if using useState
          } catch (error) {
               console.error("Error fetching accounts:", error);
          }
     };


     useEffect(() => {
          const getAccounts = async () => {
            if (clientAccounts.length === 0) {
              const clients = await fetchAccounts();
              updateClientAccounts(clients);
            }
          };
        
          const getUsers = async () => {
            if (userAccounts.length === 0) {
              const users = await fetchUsers();
              updateUserAccounts(users);
            }
          };

          const getCategories= async () => {
            if (googleCategories.length === 0) {
              const google = await fetchGoogle();
              updateGoogleCategories(google);
            }
          };

          const decodeUser = async() => {
               if (Array.isArray(myAccount) && myAccount.length === 0) {
                   const token = localStorage.getItem('LGOUser');
                   if (token) {
                         const decoded = jwtDecode(token);
                         const currentTime = Math.floor(Date.now() / 1000);
                         if (decoded.exp && decoded.exp < currentTime) {
                              localStorage.removeItem('LGOUser');
                              navigate('/login');
                          } else {
                              updateMyAccount(decoded); // Your function
                          }
                   } else {
                         navigate('/login');
                   }
                }
          }

          decodeUser();
          getAccounts();
          getUsers();
          getCategories();
          // eslint-disable-next-line
        }, []);
        



     return (
          <div className="layout">
               <Sidebar />
               <div className="main">
                    <NavBar />
                    <TheOutlet />
               </div>
          </div>
     );
};

export default Layout;
